(() => {
  if (window.__qrTrustBarInit) return;
  window.__qrTrustBarInit = true;

  const initTrustBar = (root) => {
    const scope = root || document;
    const cards = scope.querySelectorAll('.trust-bar__card:not([data-trust-observed])');
    if (!cards.length) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduceMotion) {
      cards.forEach((card) => {
        card.dataset.trustObserved = 'true';
        card.classList.add('is-visible');
      });
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2, rootMargin: '0px 0px -40px 0px' }
    );

    cards.forEach((card) => {
      card.dataset.trustObserved = 'true';
      observer.observe(card);
    });
  };

  document.addEventListener('DOMContentLoaded', () => initTrustBar());
  document.addEventListener('shopify:section:load', (event) => initTrustBar(event.target));

  if (document.readyState !== 'loading') {
    initTrustBar();
  }
})();
